var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"base-chip no-select",class:{ shrink: _vm.shrink },style:({
    backgroundColor: _vm.styles[`${_vm.chipColor}Background`],
    width: _vm.width,
    fontWeight: 600
  }),attrs:{"label":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }